import { render, staticRenderFns } from "./UIEditor.vue?vue&type=template&id=79808daa&lang=pug&"
import script from "./UIEditor.vue?vue&type=script&lang=js&"
export * from "./UIEditor.vue?vue&type=script&lang=js&"
import style0 from "./UIEditor.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/node/authoring/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('79808daa')) {
      api.createRecord('79808daa', component.options)
    } else {
      api.reload('79808daa', component.options)
    }
    module.hot.accept("./UIEditor.vue?vue&type=template&id=79808daa&lang=pug&", function () {
      api.rerender('79808daa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/editor/ui/UIEditor.vue"
export default component.exports